/**
 * Profile form validation schema
 * Validates user profile data
 */

import * as Yup from 'yup'
import { FORM_LABELS, LABELS } from '@constants'

/**
 * Profile validation schema
 * - Name is required and has max length
 */
export const profileValidationSchema = () =>
  Yup.object().shape({
    name: Yup.string()
      .required(FORM_LABELS.REQUIRED(LABELS.NAME))
      .max(255, FORM_LABELS.MAX_LENGTH(LABELS.NAME, 255)),
  })
